'use client';

import ChevronIcon from '@/fo/icons/base/icons/chevron.svg';
import CloseIcon from '@/fo/icons/base/icons/close.svg';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitInputBase, UiKitInputBaseProps } from '@/fo/ui/kit/input/base';

import { styles } from './UiKitInputPromo.styles';

export interface UiKitInputPromoProps extends UiKitInputBaseProps {
  loading?: boolean;
  onSubmit?: () => void;
  onClear?: () => void;
}

export function UiKitInputPromo({
  error,
  success,
  loading,
  label,
  helperText,
  onSubmit,
  onChange,
  onClear,
  className,
  ...props
}: UiKitInputPromoProps) {
  const slots = styles();

  const activeState = success || error;

  const handleClick = () => {
    if (activeState) {
      onClear?.();
      return;
    }

    onSubmit?.();
  };

  const renderPromoIcon = () => {
    return (
      <UiKitButtonBase
        onClick={activeState ? onClear : handleClick}
        className={slots.button()}
      >
        {activeState ? (
          <span className={slots.closeBg()}>
            <CloseIcon className={slots.close()} />
          </span>
        ) : (
          <ChevronIcon className={slots.arrow()} />
        )}
      </UiKitButtonBase>
    );
  };

  return (
    <div className={slots.base()}>
      <div className={slots.inputContainer()}>
        <UiKitInputBase
          classNameInput={slots.input({ filled: !!props.value })}
          label={label}
          error={error}
          success={success}
          onChange={onChange}
          className={className}
          readOnly={loading || success}
          icon={renderPromoIcon()}
          {...props}
        />

        {loading && (
          <div className={slots.loadingContainer()}>
            <span className={slots.loading()} />
          </div>
        )}
      </div>

      {helperText && (
        <p className={slots.message({ error, success })}>{helperText}</p>
      )}
    </div>
  );
}
